import VideoTime from './VideoTime';
export const compareInteractionTime = (a, b) => { var _a, _b; return ((_a = a.time) !== null && _a !== void 0 ? _a : 0) - ((_b = b.time) !== null && _b !== void 0 ? _b : 0); };
export function wait(ms = 100) {
    return new Promise(resolve => setTimeout(() => resolve(), ms));
}
export function wasteTime(ms) {
    if (ms > 200) {
        throw new Error('wasteTime: ms should be less than 200');
    }
    const start = Date.now();
    while (Date.now() - start < ms) {
        // waste time
    }
    console.debug('consider using wait instead of wasteTime');
}
export function nextTick() {
    return new Promise(resolve => window.requestAnimationFrame(() => resolve()));
}
export function updateTimeInput(event) {
    var _a;
    const $this = $(event.currentTarget);
    $this.val(VideoTime.parse(String((_a = $this.val()) !== null && _a !== void 0 ? _a : '')).formatForceHours());
}
/**
 * Pad a number with zeros, e.g. 1 -> 01
 */
export function addPrefixZero(numeric, length = 2) {
    return String(numeric).padStart(length, '0');
}
export function getEventProgressFactorFromMouseEvent(event) {
    const currentTarget = event.currentTarget;
    const clickPosition = event.clientX - currentTarget.getBoundingClientRect().left;
    return clickPosition / currentTarget.clientWidth;
}
